<section class="flex flex-col" [ngClass]="bgColor()">
    <div
        [ngClass]="[expand() ? 'w-screen' : 'xl:container xl:mx-auto']"
        class="relative flex flex-col select-none size-full"
    >
        <ng-content />
    </div>
</section>
